import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import PublicHeader from '../components/Layout/PublicHeader';
import StaticPageTopbar from '../components/Layout/StaticPageTopbar';

const Impressum: React.FC = () => {
  usePageTitle('Impressum');

  return (
    <div className="has-bottom-nav" style={{ minHeight: '100vh', background: '#F5F3F3', display: 'flex', flexDirection: 'column' }}>
      <div className="hide-mobile">
        <PublicHeader />
      </div>
      <StaticPageTopbar label="// IMPRESSUM" />

      <div style={{ flex: 1, width: '100%', boxSizing: 'border-box', padding: 16, maxWidth: 640, margin: '0 auto' }}>
        <h1 style={{
          fontFamily: "'Archivo',sans-serif", fontWeight: 800, fontSize: 26,
          letterSpacing: '-0.015em', color: '#2C2C2C', margin: '8px 0 16px',
        }}>Impressum</h1>
        <div className="surface-card" style={{ padding: 24, borderRadius: 16 }}>
          <div style={{ color: 'var(--text-primary)', fontSize: 14, lineHeight: 1.7 }}>
            <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>Angaben gemäß § 5 DDG</h2>
            <p style={{ marginBottom: 16 }}>
              GSK-IT UG (haftungsbeschränkt)<br />
              Siemensstr. 3<br />
              30916 Isernhagen
            </p>

            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Vertreten durch</h3>
            <p style={{ marginBottom: 16 }}>
              Geschäftsführer: Philipp Gottschalk
            </p>

            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Registereintrag</h3>
            <p style={{ marginBottom: 16 }}>
              Eintragung im Handelsregister<br />
              Registergericht: Amtsgericht Hannover<br />
              Registernummer: HRB 230960
            </p>

            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Umsatzsteuer-ID</h3>
            <p style={{ marginBottom: 16 }}>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              DE463590997
            </p>

            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Kontakt</h3>
            <p style={{ marginBottom: 16 }}>
              E-Mail: <a href="mailto:info@radsport-events.de" style={{ color: 'var(--text-primary)' }}>info@radsport-events.de</a>
            </p>

            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h3>
            <p style={{ marginBottom: 16 }}>
              Philipp Gottschalk<br />
              Siemensstr. 3<br />
              30916 Isernhagen
            </p>

            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Haftungsausschluss</h3>
            <p style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
              Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den
              allgemeinen Gesetzen verantwortlich. Nach Art. 6 und 8 der Verordnung (EU) 2022/2065
              (Digital Services Act) sind wir jedoch nicht verpflichtet, übermittelte oder
              gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die
              auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder
              Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis
              einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>

            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Verbraucherstreitbeilegung</h3>
            <p style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen (§ 36 VSBG).
            </p>

            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Datenquellen</h3>
            <p style={{ marginBottom: 16, color: 'var(--text-secondary)' }}>
              Die Ortssuche verwendet Geodaten von{' '}
              <a href="https://www.geonames.org/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--focus-color)' }}>GeoNames</a>{' '}
              (lizenziert unter CC BY 4.0). Die Umkreissuche nutzt Geokodierung auf Basis von{' '}
              <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--focus-color)' }}>OpenStreetMap</a>-Daten
              (© OpenStreetMap-Mitwirkende, ODbL).
            </p>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Impressum;
